import { ADDRESS_API_PATHS, type AddressDraft, type SavedAddress } from '../constants/addresses'
import { apiRequest } from './client'

export function fetchAddresses(): Promise<SavedAddress[]> {
  return apiRequest<SavedAddress[]>(ADDRESS_API_PATHS.root, { auth: true })
}

export function createAddress(input: AddressDraft): Promise<SavedAddress> {
  return apiRequest<SavedAddress>(ADDRESS_API_PATHS.root, {
    method: 'POST',
    auth: true,
    body: input,
  })
}

export async function deleteAddress(id: string): Promise<void> {
  await apiRequest<null>(ADDRESS_API_PATHS.item(id), {
    method: 'DELETE',
    auth: true,
  })
}

export function updateAddress(id: string, input: AddressDraft): Promise<SavedAddress> {
  return apiRequest<SavedAddress>(ADDRESS_API_PATHS.item(id), {
    method: 'PATCH',
    auth: true,
    body: input,
  })
}
